document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const sections = document.querySelectorAll('.obstacle-avoidance-section');
    if (!sections.length) return;

    // 动画参数配置
    const fadeInUp = { opacity: 0, y: '40px', ease: 'power1.inOut' };
    const tagFadeInUp = { opacity: 0, y: '20px', ease: 'power1.inOut' };

    sections.forEach((section) => {
        // 获取DOM元素
        const container = section.querySelector('.obstacle-animation-container');
        const img = section.querySelector('.animation-bg-img');
        const overlay = section.querySelector('.animation-overlay');
        const animationText = section.querySelector('.animation-text');
        const textTitle = section.querySelector('.text-title');
        const textDescription = section.querySelector('.text-description');
        const tags = [
            section.querySelector('.tag-humans'),
            section.querySelector('.tag-pets'),
            section.querySelector('.tag-small-animals'),
            section.querySelector('.tag-yard-items'),
            section.querySelector('.tag-garden-supplies')
        ].filter(Boolean);

        const mm = gsap.matchMedia();

        // 桌面端动画
        mm.add('(min-width: 769px)', () => {
            const bgHeight = img?.clientHeight || 0;
            const bgTop = `${window.innerHeight - bgHeight}px`;
            const textTop = `${bgHeight - window.innerHeight + 96}px`;
            
            // 初始化动画状态
            gsap.set(overlay, { opacity: 0 });
            gsap.set(animationText, { top: textTop });
            gsap.set(textTitle, { ...fadeInUp });
            gsap.set(textDescription, fadeInUp);
            gsap.set(tags, tagFadeInUp);
            gsap.set(container, { height: `${bgHeight}px` });

            // 创建动画时间线
            const timeline = gsap.timeline({
                scrollTrigger: {
                    id: 'lidaxObstacleAvoidanceScrollTrigger',
                    trigger: section,
                    start: `top ${bgTop}`,
                    end: '+=200%',
                    scrub: 1,
                    pin: true,
                    anticipatePin: 1,
                    markers: false
                },
            });

            // 添加动画序列
            timeline
                .to(overlay, { opacity: 1, duration: 0.4 }, 0)
                .to(textTitle, { opacity: 1, y: 0, duration: 0.4 }, 0.4)
                .to(textDescription, { opacity: 1, y: 0, duration: 0.4 }, 0.6);
            
            // 标签动画
            tags.forEach((tag, i) => {
                timeline.to(tag, { opacity: 1, y: 0, duration: 0.3 }, 0.8 + i * 0.1);
            });

            return () => ScrollTrigger.getAll({ trigger: section }).forEach(t => t.kill());
        });

        // 移动端动画
        mm.add('(max-width: 768px)', () => {
            gsap.set(overlay, { opacity: 0 });
            gsap.set(tags, tagFadeInUp);

            const timeline = gsap.timeline({
                scrollTrigger: {
                    id: 'lidaxObstacleAvoidanceScrollTrigger',
                    trigger: section,
                    start: 'top top',
                    end: '+=200%',
                    scrub: 1,
                    pin: true,
                    anticipatePin: 1,
                },
            });

            timeline
                .to(overlay, { opacity: 1, duration: 0.4 }, 0)
                .to(tags, { opacity: 1, y: 0, duration: 0.3, stagger: 0.1 }, 0.2);

            return () => ScrollTrigger.getAll({ trigger: section }).forEach(t => t.kill());
        });
    });
});
